import React from "react";
import Typography from "@material-ui/core/Typography";
const Learn = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Learn Invifo
      </Typography>
      <Typography paragraph variant="h5">
        New to Invifo platform? It's easy to learn if you know where to start!
        This guide will help you to get started quickly.
      </Typography>
      <Typography paragraph variant="body1">
        The Invifo platform users are coming from various company departments,
        have different backgrounds, and with different learning styles. Whether
        you prefer a more theoretical or practical approach, we hope you’ll find
        this section helpful. But, don't worry, the Invifo platform is designed
        simple and modular based on each processing area like Finance, Sales,
        Procurement, Inventory, CRM, etc. It only takes a few hours to fully
        understand each module. Like any unfamiliar technology, the Invifo
        platform does have a learning curve. With practice and some patience,
        you will soon get the hang of it.
      </Typography>
    </React.Fragment>
  );
};

export default Learn;
